<div class="gtmt-container" style="
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow-y: auto;">

  <mat-grid-list [cols]="1" [rowHeight]="'3rem'" style="width: 100%;">
    <mat-grid-tile rowspan="2">
      <mat-toolbar style="
        font: 600 normal 2.7rem / 3.2rem Montserrat;
        color: #003DA5;
        justify-content: center;
        background: transparent;">
        🚧Cap Mailing Plateforme est en cours de maintenance🚧
      </mat-toolbar>
    </mat-grid-tile>

    <mat-grid-tile rowspan="9">
      <p>
          Cher(e) utilisateur(trice), <br><br>
          Notre plateforme est actuellement en maintenance pour une mise à jour et sera de retour très bientôt.
          <br><br>
          Nous mettons tout en œuvre pour améliorer votre expérience et vous remercions pour votre patience.
          <br><br>
          À très bientôt sur <Strong>Cap Mailing Plateforme</Strong> !
          <br><br>
          L’équipe <Strong>Cap Mailing Plateforme</Strong> 
      </p>
  </mat-grid-tile>

    <mat-grid-tile rowspan="6">
      <div class="logo" style="
        width: 100%;
        height: 100%;
        background: center no-repeat url('../../../../assets/images/la_poste_solutions_logo.png');">
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</div>
